module.exports = __webpack_public_path__ + "static/media/grid.39a078bd.jpg";